export enum Routes {
  Main = "/",
  Login = "/login",
  SignUp = "/signup",
  Admin = "/ad/",
  AdminDashboard = "/ad/",
  AdminSettings = "/ad/settings",
  AdminCustomers = "/ad/customers",
  AdminSchedule = "/ad/schedule",
  Checkout = "/ad/checkout",
  PublicBooking = "/company/:companyId/booking",
  VerifyEmail = "/verify-email/:token",
  GuestAccount = "/account/bookings",
}
